var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n#SidenavForm {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    // props is the attributes to <sidenav></sidenav>.
    // Note the params is the same passing of choices for each field
    // (set by the sidenavs controller and the views controller). This is
    // where the current view's controller sets a default values (if any)
    // other than all.
    // The rest are figured out by the key/field sent over.
    // Options are the selection in each of those fields that the user wanted to filter with. Also CropYear in Options can be just
    // a string or an array (for the comparison).
    props: ['view', 'key', 'prefix', 'fields', 'fieldList', 'params'],
    data: function data() {
        return { // new data for each instance (not same/connected)
            enabled: false,
            main_content: null, // main page...

            Options: {
                search: "",
                CropYear: [],
                GrowerName: null,
                VarietyGroup: null,
                VarietyName: null,
                CommodityType: null,
                Commodity: null,
                Field: null,
                ReportGroupName: null,
                MonthFilter: null,
                DateCreated: null,
                DateModified: null,
                //Graph: null,
                XAxis: null,
                YAxis: null
            },
            errors: [],
            reloading: false,

            // All selects need defaults to keep binding working.
            cropYears: [],
            cropYearList: [],
            growerNames: [],
            varietyGroups: [],
            varietyNames: [],
            commodityTypes: [],
            commodities: [],
            fieldNames: [],
            reportGroupNames: [],
            monthFilters: [],
            dateCreateds: [],
            dateModifieds: [],
            graphs: [],
            xaxis: [],
            yaxis: []
        };
    },
    computed: {
        // The 'available' methods: Need to be explicit about filters.
        // Filters used should be ones already established by passing data.
        // Ex: this.growerNames only has CropYear as a filter as this is the
        // only key in this.growerNames. Using other filters will not work
        // though will not error out. Just do nothing if used.
        availableCropYears: function availableCropYears() {
            //  No filters. This is the most basic filtering.
            return this.availableField(this.cropYears, 'CropYear');
        },
        availableGrowers: function availableGrowers() {
            var filters = {
                CropYear: this.Options.CropYear
            };

            return this.availableField(this.growerNames, 'GrowerName', filters);
        },
        availableVarietyNames: function availableVarietyNames() {
            var filters = {
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName
            };
            return this.availableField(this.varietyNames, 'VarietyName', filters);
        },
        availableVarietyGroups: function availableVarietyGroups() {
            var filters = {
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName,
                VarietyName: this.Options.VarietyName
            };
            return this.availableField(this.varietyGroups, 'VarietyGroup', filters);
        },
        availableCommodityTypes: function availableCommodityTypes() {
            var filters = {
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName,
                VarietyName: this.Options.VarietyName,
                VarietyGroup: this.Options.VarietyGroup
            };

            return this.availableField(this.commodityTypes, 'CommodityType', filters);
        },
        availableCommodities: function availableCommodities() {
            var filters = {
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName,
                VarietyName: this.Options.VarietyName,
                VarietyGroup: this.Options.VarietyGroup,
                CommodityType: this.Options.CommodityType
            };
            return this.availableField(this.commodities, 'Commodity', filters);
        },
        availableMonthFilters: function availableMonthFilters() {
            var filters = {
                // maybe add more dependencies if seems to need
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName,
                CommodityType: this.Options.CommodityType,
                Commodity: this.Options.Commodity,
                VarietyName: this.Options.VarietyName,
                VarietyGroup: this.Options.VarietyGroup
            };

            return this.availableField(this.monthFilters, 'MonthFilter', filters);
        },
        availableReportGroupNames: function availableReportGroupNames() {
            var filters = {
                // maybe add more dependencies if seems to need
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName
            };

            return this.availableField(this.reportGroupNames, 'ReportGroupName', filters);
        },
        availableDateCreateds: function availableDateCreateds() {
            var filters = {
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName,
                MonthFilter: this.Options.MonthFilter,
                ReportGroupName: this.Options.ReportGroupName
            };

            return this.availableField(this.dateCreateds, 'DateCreated', filters);
        },

        availableDateModifieds: function availableDateModifieds() {
            var filters = {
                CropYear: this.Options.CropYear,
                GrowerName: this.Options.GrowerName,
                MonthFilter: this.Options.MonthFilter,
                ReportGroupName: this.Options.ReportGroupName,
                DateCreated: this.Options.DateCreated
            };

            return this.availableField(this.dateModifieds, 'DateModified', filters);
        }

    },
    methods: {
        // Filter the the data after response from SidenavController@sidenav based
        // one what filters given, if any. This will determine what are the options in each selection. Note that values keys should match the filter. In otherwords,
        // if VarietyGroup does not exist in the values, then that filter won't work
        // because it does not exist in values. Values should be pre-established in
        // the SidenavController.
        // Responds with data based on selection to the charts after hitting
        // the refresh button.
        availableField: function availableField(values, field) {
            var filters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


            // If multiple values for filter, allow ANY of...

            // DEBUG --------------------------------
            // console.log("FILTERS=");
            // console.log(JSON.stringify(filters));

            // console.log("VALUE=");
            // console.log(JSON.stringify(values));
            // --------------------------------------

            var available = [];

            // For Date special formating.
            var dateFields = ["DateCreated", "DateModified"];
            var dateFieldIndices = []; // Use in the 'availableField'

            for (var r = 0; r < values.length; r++) {
                var row = values[r];
                // console.log("ROW=");
                // console.log(JSON.stringify(row));

                var match = true;
                for (var f in filters) {
                    if (f in row) // Only bother if we have a field same as filter.
                        {
                            // DEBUG -----------------------------------------
                            // Checking the case when filter is in the row.
                            // if(tracker==="HELLO"){
                            //     console.log('commodities');
                            //     console.log("f is in row");
                            //     console.log("CHECK FILTER="+f+"="+filters[f].toString());
                            //     console.log("ROW HAS="+f);
                            // }
                            //------------------------------------------------

                            // The case if an element in fitler is an array.
                            if (filters[f] instanceof Array) {
                                if (jQuery.inArray(row[f].toString(), filters[f]) < 0) {
                                    // DEBUG -----------------------------------------
                                    // console.log("DIDNT FIND IN ARRAY="+row[f].toString());
                                    // console.log(filters[f]);
                                    // console.log(jQuery.inArray(row[f].toString(), filters[f]));
                                    //--------------------------------------------------

                                    match = false;
                                }
                            } else {
                                // The case if an element in filter is a string.
                                // If filter is empty or row does not match filter, then
                                // match is false.
                                if (filters[f] && row[f].toString() !== filters[f].toString()) {
                                    match = false;
                                }
                            }
                        } else {
                        // Checking the case that filter is not in the row
                        // but exist in data.

                        // DEBUG -----------------------------------------
                        //
                        // console.log('availableVarietyNames');
                        // console.log("f is out of row");
                        // console.log("CHECK FILTER="+f+"="+filters[f].toString());
                        // console.log("ROW HAS="+JSON.stringify(row));
                        //
                        //  -----------------------------------------------/

                    }
                }
                //console.log ("MATCH OF "+row[field]+"="+match);

                if (match) {
                    // Find the indices that are dates. These will have special
                    // way of displaying while maintaining value.
                    if (dateFields.includes(field)) {
                        dateFieldIndices.push(available.length);
                    }

                    available[available.length] = row[field];
                }
            }
            // DEBUG -----------------------------------------
            // console.log("AVAILABLE=");
            // console.log(available);
            // -----------------------------------------------

            // Now convert to dropdown k=>v
            var data = {};

            for (var i = 0; i < available.length; i++) {
                // If indices is a date, then formate the value
                if (dateFieldIndices.includes(i)) {
                    var tempDate = new Date(available[i]);
                    var tempDateStr = tempDate.toLocaleDateString() + " " + tempDate.toLocaleTimeString();

                    // Inorder to be able to filter by date
                    data[available[i]] = tempDateStr;
                } else {
                    data[available[i]] = available[i];
                }
            }

            // DEBUG -----------------------------------------
            // console.log("SEL=");
            // console.log(data);
            // -----------------------------------------------

            return data;
        },
        notEmpty: function notEmpty(prop) {
            return !$.isEmptyObject(prop);
        },
        multipleOptions: function multipleOptions(prop) {
            return (0, _keys2.default)(prop).length > 1;
        },
        resetOptions: function resetOptions() {
            this.Options = {};
            refreshForm(null, false, function () {
                updateContent();
            });
        },
        loadGraphPage: function loadGraphPage() {
            // Made this more universal than just "/comparison/"+this.key
            // in case another view needs to use the loadGraphPage.
            window.location.href = "/" + this.view + "/" + this.key;
        },

        // Returns the url query based on this.Options.
        // Note the need to escape some characters.
        queryString: function queryString() {
            var qstring = '';

            var keys = (0, _keys2.default)(this.Options);

            for (var k in keys) {
                if (this.Options[keys[k]] instanceof Array) {
                    // Need any keys/values to escape characters that would
                    // effect the url for query. Ex: '&' in some grower's name.
                    var tempStr = "";

                    for (var ok in this.Options[keys[k]]) {
                        tempStr = this.Options[keys[k]][ok] || '';
                        tempStr = encodeURIComponent(tempStr);

                        qstring += "Options[" + keys[k] + "][" + ok + "]=" + tempStr + "&";
                    }
                } else {
                    tempStr = this.Options[keys[k]] || '';
                    tempStr = encodeURIComponent(tempStr);

                    qstring += "Options[" + keys[k] + "]=" + tempStr + "&";
                }
            }

            return qstring;
        },

        // This updates data in form AND also saves
        // into session for future page loads.
        refreshForm: function refreshForm(e) {
            var _this = this;

            var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            // Convert this.Options to query string
            this.reloading = true;

            // Don't pass options on init since we dont have yet.
            var qs = init ? '' : this.queryString();

            // The base sidenav url for the current view.
            // Includes the requested fields.
            var baseUrl = '/' + this.view + '/sidenav/' + (this.prefix ? this.prefix + "." : "") + this.key + '/' + this.fields;
            var qryUrl = baseUrl + "?" + qs;

            this.$http.get(qryUrl).then(function (response) {
                // sidenav response
                // Set props

                for (var k in response.data) {
                    // DEBUG-------------------------------------------------
                    // console.log("SETTING "+k+"=");
                    // console.log(response.data[k]);
                    // if (k == 'Options')
                    // {
                    //     for(var ok in response.data[k])
                    //     {
                    //         this.Options.$set(ok, response.data[k][ok]);
                    //     }
                    // } else {
                    //  console.log("SETTING "+k+"=");
                    //  console.log(response.data[k]);
                    //  ok we are probably getting bad data, CropYear=2010
                    //  XXX TODO we should be able to reset data by changing+ refresh
                    //  graph...May not even need to do this with current arrangements.
                    //  ------------------------------------------------------

                    _this.$set(k, response.data[k]);
                }

                // DEBUG -----------------------------------------
                //console.log(response.data);
                //NOT first time around!
                //console.log("INIT="+init);
                // -----------------------------------------------

                _this.reloading = false;

                if (callback) {
                    callback();
                }
            }).catch(function (error) {
                console.log("COULD NOT LOAD SIDEBAR");
                console.log(error);
            });
        },

        // Main window of the content to be displayed after
        // sidenav options are selected (if any).
        // Note the need to rebind 'bottom_scripts' from
        // laravel since deleted DOM's lose there bindings.
        updateContent: function updateContent(e) {
            var _this2 = this;

            $.loading();

            var formData = this.queryString();

            // URL needs
            // There two cases one with pagination and one without pagination.
            // Without pagination then you need the "?". With pagination then you
            // need to change "?" to an "&" because a query alreayd happened.
            var currentUrl = window.location.href;
            var getUrl = '';

            // With Pagination
            if (currentUrl.indexOf('page') !== -1) {

                getUrl = currentUrl + "&" + formData;

                // String replace to page 1 because after filtering, page number is resetted
                // in the pagination
                var adjustedGetUrl = getUrl.replace(/page=(.+?)&/, 'page=1&');
                getUrl = adjustedGetUrl;
            } else {
                // Without Pagination
                getUrl = currentUrl + "?" + formData;
            }

            this.$http.get(getUrl).then(function (response) {

                // DEBUG-----------------------------------
                // console.log("URL=" + getUrl);
                // console.log("main content response=");
                // console.log(response.data);
                // console.log(response.data.html);
                // Should already be ajax (without layout)
                // ----------------------------------------


                // Below line will strip any events at the bottom of page.
                $('#content').html(response.data.html);

                // just in case we have stuff there.
                _this2.$compile($('#content').get(0));

                $.loading(false);

                _this2.readyToUpdate = false; // Hide refresh button

                $(document).trigger("bottomScriptEvent");
            }).catch(function (error) {
                console.log("COULD NOT LOAD CONTENT");
                console.log(error);
            });
        }

    },

    ready: function ready() {
        $('#left_title_controls').html('<button type="button" class="bold collapsed glyphicon glyphicon-cog btn btn-primary btn-sm" data-target="#sidenav" aria-expanded="false" aria-controls="sidenav" onClick="$(\'#sidenav\').toggle();"> </button>');
        this.refreshForm(null, true);
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div>\n    <form id=\"SidenavForm\" method=\"POST\" action=\"{{ '/'+ view +'/sidenav/'+key+'/'+fields }}\">\n        <div v-show=\"!reloading\">\n            <boot-select v-if=\"params &amp;&amp; notEmpty(params.graphs)\" :options=\"params.graphs\" :model.sync=\"key\" :value=\"key\" @change=\"loadGraphPage\" label=\"Comparison Type\"></boot-select>\n\n            <boot-input v-if=\"fieldList &amp;&amp; fieldList.includes('search')\" type=\"text\" :model.sync=\"Options.search\" label=\"Search\" placeholder=\"Keywords\"></boot-input>\n\n            <div v-if=\"params &amp;&amp; notEmpty(params.cropYears)\">\n                <div v-for=\"cropYear in params.cropYears\">\n                    <boot-select :options=\"params.cropYears\" :placeholder=\"$index > 0 ? '- None -' : null \" v-if=\"$index < 3\" class=\"cropYears\" :id=\"'CropYear'+$index\" :order=\"-1\" :model.sync=\"Options.CropYear[$index]\" :label=\" !$index ? 'Crop Year(s)':null \"></boot-select>\n                </div>\n            </div>\n            <div v-else=\"\">\n                <boot-select v-if=\"notEmpty(params.CropYear)\" :options=\"params.CropYear\" :order=\"-1\" :model.sync=\"Options.CropYear\" label=\"Crop Year\"></boot-select>\n            </div>\n\n            <boot-select v-if=\"notEmpty(availableGrowers)\" placeholder=\"- All Growers -\" :options=\"availableGrowers\" :model.sync=\"Options.GrowerName\" label=\"Growers\"></boot-select>\n\n            <boot-select v-if=\"notEmpty(availableVarietyNames)\" placeholder=\"- All Varieties -\" :options=\"availableVarietyNames\" :model.sync=\"Options.VarietyName\" label=\"Varieties\"></boot-select>\n\n            <boot-select v-if=\"notEmpty(availableVarietyGroups)\" placeholder=\"- All Variety Groups -\" :options=\"availableVarietyGroups\" :model.sync=\"Options.VarietyGroup\" label=\"Variety Groups\"></boot-select>\n\n            <boot-select v-if=\"notEmpty(commodityTypes)\" placeholder=\"- All Commodity Types -\" :options=\"availableCommodityTypes\" :model.sync=\"Options.CommodityType\" label=\"Commodity Types\"></boot-select>\n\n            <boot-select v-if=\"notEmpty(commodities)\" :options=\"availableCommodities\" placeholder=\"- All Commodities -\" :model.sync=\"Options.Commodity\" label=\"Commodities\"></boot-select>\n\n            <!-- Maybe needed. If so, filtering needs to be addressed. -->\n            <!--\n            <boot-select v-if=\"notEmpty(fieldNames)\" :options=\"availableFields\" placeholder=\"- All Fields -\" :model.sync=\"Options.Field\" label=\"Fields\"></boot-select>\n            -->\n\n            <boot-select v-if=\"notEmpty(availableMonthFilters)\" :options=\"availableMonthFilters\" placeholder=\"- All Months -\" :model.sync=\"Options.MonthFilter\" id=\"MonthFilter\" label=\"Months\"></boot-select>\n\n            <boot-select class=\"\" v-if=\"params &amp;&amp; multipleOptions(params.xAxis)\" :options=\"params.xAxis\" :model.sync=\"Options.XAxis\" label=\"X-Axis\"></boot-select>\n\n            <boot-select class=\"\" v-if=\"params &amp;&amp; multipleOptions(params.yAxis)\" :options=\"params.yAxis\" :model.sync=\"Options.YAxis\" label=\"Y-Axis\"></boot-select>\n\n            <!-- todo 'after' section -->\n            <boot-select v-if=\"notEmpty(reportGroupNames)\" :options=\"availableReportGroupNames\" placeholder=\"- All -\" :model.sync=\"Options.ReportGroupName\" label=\"Report Group\"></boot-select>\n\n\t\t\t<!-- Custom select that is specific to ordering of date objects. They are ordered from latestest to oldest. -->\n\t\t\t<boot-select-date v-if=\"notEmpty(dateCreateds)\" :options=\"availableDateCreateds\" orderdate=\"desc\" placeholder=\"- All Dates Created -\" :model.sync=\"Options.DateCreated\" id=\"DateCreated\" label=\"Date Created\"></boot-select-date>\n\t\t\t<boot-select-date v-if=\"notEmpty(dateModifieds)\" :options=\"availableDateModifieds\" orderdate=\"desc\" placeholder=\"- All Dates Modified -\" :model.sync=\"Options.DateModified\" id=\"DateModified\" label=\"Date Modified\"></boot-select-date>\n\n\n            <!-- Hidden reset button to reset the options-->\n            <div style=\"display: none;\" class=\"right\">\n                <a title=\"Reset\" href=\"\" @click.stop=\"resetOptions\" id=\"SidenavReset\"><span class=\"btn btn-warning glyphicon glyphicon-trash\"></span></a>\n            </div>\n        </div>\n\n        <div v-show=\"reloading\" class=\"alert alert-info\"><i class=\"fa fa-spin fa-spinner\"></i> Please wait...</div>\n\n        <div class=\"form-group\" v-show=\"!reloading\">\n            <button type=\"submit\" @click.prevent=\"updateContent\" class=\"btn btn-success\">Refresh</button>\n        </div>\n\n        <div class=\"clear\"></div>\n    </form>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n#SidenavForm {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-8665c650", module.exports)
  } else {
    hotAPI.update("_v-8665c650", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}